module.exports = __webpack_public_path__ + "img/fukui.2ddd0a19.png";